/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-31 14:23:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-04 09:35:55
 */
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import {
  getMaterialsCategoryName,
  getMaterialsName,
  Materiales,
  MaterialsCategories,
} from '../../../../../models/commodity'
import { useDispatch } from 'react-redux'
import { setAddtionCurrent } from '../addtionDrugSlice'
import {
  DateSelect,
  RecentTimes,
} from '../../../../../compnents/form/DateSelect'
const { Option } = Select

export const ButtonQuery = (props: {
  detail: any
  onRemove: () => void
  onValueChange: (queries: any) => void
  onSave: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch()
  return (
    <>
      <Row style={{ marginBottom: '10px' }} gutter={10}>
        <Col span={2}>
          <Button
            type='primary'
            danger
            style={{ width: '100%' }}
            onClick={() => {
              props.onRemove()
            }}
            disabled={props.detail.state ? true : false}
          >
            删除
          </Button>
        </Col>
        <Col span={3}>
          <Button
            htmlType='submit'
            type='primary'
            style={{ width: '100%' }}
            onClick={() => {
              props.onSave()
            }}
            disabled={props.detail.state ? true : false}
          >
            添加养护药品
          </Button>
        </Col>
      </Row>
      <Form
        form={form}
        onFieldsChange={(_, fs) => {
          dispatch(setAddtionCurrent(1))
          props.onValueChange({
            ...form.getFieldsValue(),
            name: form.getFieldsValue().name
              ? form.getFieldsValue().name
              : null,
            deadlineStart:form.getFieldsValue()?.timeHead ? form.getFieldsValue()?.timeHead : undefined,
            deadlineEnd :form.getFieldsValue()?.timeTail ? form.getFieldsValue()?.timeTail : undefined,
            timeHead: undefined,
            timeTail: undefined
          })
        }}
        autoComplete='off'
      >
        <Row
          style={{
            margin: '0 0 10px 0',
          }}
          justify='space-between'
          wrap={false}
        >
          <Space>
            <Form.Item name='name' noStyle>
              <Input
                placeholder='药品名称或助记码'
                allowClear
                prefix={<SearchOutlined />}
                style={{ width: '12rem' }}
              />
            </Form.Item>
            <Form.Item name='materialsCategory' noStyle>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder='药品分类'
                allowClear
                style={{ width: '8rem' }}
              >
                {Materiales.map((v) => (
                  <Option value={v} key={v}>
                    {getMaterialsName(v)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='time' noStyle>
              <DateSelect
                placeholder='有效期至'
                allowClear={false}
                labelPrefix=''
                options={RecentTimes}
                style={{ width: '8rem' }}
                namePrefix='time'
              />
            </Form.Item>
            <Button
              htmlType='submit'
              type='primary'
              style={{ width: '100%', float: 'right' }}
            >
              查询
            </Button>
          </Space>
        </Row>
      </Form>
    </>
  )
}
